module.exports = __webpack_public_path__ + "img/jifen-5@2x.9fdbce60.png";